export interface BulkArchiveFailure {
  id: string;
  reason: string;
}

export interface BulkArchiveResult {
  succeeded: string[];
  failed: BulkArchiveFailure[];
}

export type BulkArchiveEntityLabel = 'Fulfillment Context' | 'Origin';

export const BULK_ARCHIVE_ABORTED_REASON = 'aborted';
